import api from '@/api'

export default {
  namespaced: true,
  state: {
    data: {},
    recentLogged: '',
    token: '',
    attachment: ''
  },
  mutations: {
    saveToken (state, t) {
      localStorage.setItem('token', t)
      localStorage.setItem('recent_logged', new Date())
    },
    loadToken (state) {
      state.token = localStorage.getItem('token')
      state.recentLogged = localStorage.getItem('recent_logged')
    },
    removeToken (state) {
      localStorage.removeItem('token')
    }
  },
  actions: {
    async load (context) {
      const res = await api.getBIZ(`/api/logged`)
      context.state.data = res.data
      await context.dispatch('loadAttachment')
    },
    async loadAttachment (context) {
      const convertBlobToBase64 = (blob) => new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onerror = reject
        reader.onload = () => {
          resolve(reader.result)
        }
        reader.readAsDataURL(blob)
      })
      const res = await context.dispatch('getAttachment', {content: context.state.data, name: 'photo'})
      if (res.data.length < 1) { return }
      const file = new Blob([res.data], {type: 'image/png'})
      context.state.attachment = await convertBlobToBase64(file)
    },
    async getAttachment (context, {content, name}) {
      const query = encodeURIComponent(`${content._id}/${name}`)
      const res = await api.request(api.host_biz, `/api/content/attachment?uri=${query}`, {method: 'GET', responseType: 'blob'})
      return res
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js